<template>
  <div style="display: contents;">
    <div  v-if="this.gmoPageStore.gmoPage" v-html="this.gmoPageStore.gmoPage"></div>
    <iframe v-if="this.gmoPageStore.gmoUrl" ref="iframe" :src="this.gmoPageStore.gmoUrl" width="100%" :height="iframeHeight" @load="updateIframeHeight()" frameborder="0" ></iframe>
  </div>
</template>

<script>
import { useGmoPageStore } from '@/store/gmoPage'

export default {
  computed: {
    gmoPageStore: function () {
      return useGmoPageStore()
    },
    paymentData () {
      return this.$route.query
    }
  },
  data () {
    return {
      iframeHeight: '1000px' // 初期値設定
    }
  },
  mounted () {
    window.addEventListener('message', this.receiveMessage, false)
  },
  methods: {
    // 画面サイズとiframeのサイズを合わせる,
    updateIframeHeight () {
      this.iframeHeight = window.innerHeight + 'px'
    },
    receiveMessage (event) {
      // postMessageを受け取ったらrouterセットする
      // 許可するoriginを設定 web-apiのドメインを指定する
      console.warn('postMessage()受信', event.origin)

      // 画面移動
      if (event.data.action === 'navigateVue') {
        console.log('iframeからpostMessage()受信 Vue Routerセット:', event.data.route)
        console.log('iframeからpostMessage()受信 parameter:', event.data.params)
        // webviewのstateとpostmessageされたparamをマージする
        const mergedQuery = { ...this.paymentData, ...event.data.params }
        this.iframeVisible = false
        this.$router.push({
          name: event.data.route + 'V3',
          query: mergedQuery
        })
      }

      // 決済処理
      const bean = event.data
      if (
        (bean && bean.AccessID && bean.Token) ||
        (bean && bean.transId && bean.t)
      ) {
        console.log('決済開始のpostMessage()受信 - 新規タブで開く')

        // 決済用のURLを作成
        const url = this.createPaymentUrl(bean)

        // WebView（ネイティブ）なら専用メソッドを呼び出す
        if ('Android' in window) {
          /* eslint-disable-next-line no-undef */
          Android.openBrowser(url)
        } else if ('webkit' in window) {
          /* eslint-disable-next-line no-undef */
          webkit.messageHandlers.openBrowser.postMessage(url)
        } else {
          // 通常のブラウザならフォームで開く
          this.openPaymentWindow(bean)
        }
      }
    },
    createPaymentUrl (bean) {
      const params = new URLSearchParams()
      if (bean.AccessID && bean.Token) {
        params.append('AccessID', bean.AccessID)
        params.append('Token', bean.Token)
      } else {
        params.append('transId', bean.transId)
        params.append('t', bean.t)
      }
      return `${bean.action}?${params.toString()}`
    },
    openPaymentWindow (bean) {
      // ブラウザ処理
      const form = document.createElement('form')
      form.action = bean.action
      form.method = bean.method
      form.target = '_blank' // 新規タブで開く

      if (bean.AccessID && bean.Token) {
        this.addParam(form, 'AccessID', bean.AccessID)
        this.addParam(form, 'Token', bean.Token)
      } else {
        this.addParam(form, 'transId', bean.transId)
        this.addParam(form, 't', bean.t)
      }

      // フォーム送信
      document.body.appendChild(form)
      form.submit()
      document.body.removeChild(form) // 送信後に削除
    },
    // フォームにパラメータを追加するヘルパー関数
    addParam (form, paramName, paramValue) {
      const input = document.createElement('input')
      input.type = 'hidden'
      input.name = paramName
      input.value = paramValue
      form.appendChild(input)
    }
  }
}
</script>

<style></style>
